import { ScrollView, View } from 'react-native';
import { Button, IconButton, Text, useTheme } from "react-native-paper";
import React, { useContext, useEffect, useReducer, useRef, useState } from "react";
import ReactToPrint from 'react-to-print';
import * as XLSX from "xlsx"
import Preferance from '../constants/Preferances';

import { MaterialIcons } from '@expo/vector-icons';
import Global from '../constants/global';
import { useSelector } from 'react-redux';

const pageStyle = `

  @media all {
    .pagebreak {
      display: none;
      page-break-after: always;
    }
  }

  @media print {
    .pagebreak {
      page-break-after: always;
    }
  }
`;
export default function PrintSubjectSheet({ navigation, route }) {
    const pref = useContext(Preferance)
    const S = useSelector(s => s.list.SubjectSheet[route.params.classId + route.params.year + route.params.examName])
    const Page = ({ s }) => {
        return <div style={{ display: "flex", flexDirection: "column", pageBreakInside: "avoid", flex: 1 }}>
            <Text variant="displaySmall" style={{ textAlign: "center", marginTop: 30, padding: 10, fontWeight: "bold", flex: 1 }}>{"શ્રી ઠક્કરબાપા વિદ્યામંદિર"}</Text>
            <View style={{ flex: 1, padding: 10, flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                <Text style={{ color: "black", textAlign: "center" }} variant="titleLarge">પરીક્ષાનું ગુણપત્રક - {S?.examName} - વર્ષ  </Text>
                <Text style={{ color: "black", textAlign: "center", fontWeight: "bold" }} variant="titleLarge">{S.year}</Text>
            </View>

            <View style={{ flexDirection: "row", marginTop: 20, }}>
                <Text style={{ flex: 2, fontWeight: "900" }} variant="titleLarge">{S?.className}  {S?.div}</Text>
                <Text variant="titleLarge" style={{ textAlign: "center", flex: 2 }}>પરીક્ષાની તારીખ  __________</Text>
            </View>
            <View style={{ marginTop: 20, flexDirection: "row" }}>
                <View style={{ flexDirection: "row", flex: 2 }}>
                    <Text style={{}} variant="titleLarge">વિષય  </Text>
                    <Text style={{ fontWeight: "900", borderBottomWidth: 1 }} variant="titleLarge">{s?.name} </Text>
                </View>
                <View style={{ flexDirection: "row", flex: 1 }}>
                    <Text style={{}} variant="titleLarge">કુલગુણ  </Text>
                    <Text style={{ borderBottomWidth: 1, fontWeight: "900" }} variant="titleLarge">{s?.totalMarks}</Text>
                </View>
            </View>
            <View style={{ flexDirection: "row", marginTop: 30 }}>
                <RollSheet till={17} above={0} subject={s} />
                <RollSheet till={34} above={18} subject={s} />
                <RollSheet till={51} above={35} subject={s} />
                <RollSheet till={68} above={52} subject={s} />
                <RollSheet till={85} above={69} subject={s} />
            </View>
            <View style={{ flexDirection: "row", marginTop: 10 }}>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{s.pass}</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>પાસ</Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{s.fail}</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>નાપાસ </Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{s.absent}</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>Absent</Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{s.fail + s.pass + s.absent}</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>કુલ</Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{Math.round((s.pass * 100) / (s.fail + s.pass))}%</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>ટકાવારી</Text>
                </View>
            </View>

            <View style={{ flexDirection: "row", marginTop: 40 }}>
                <Text variant="titleLarge" style={{ textAlign: "center" }}>તપાસનારની સહી </Text>
                <Text variant="titleLarge" style={{ flex: 2, textAlign: "center", borderBottomWidth: 1, borderStyle: "solid" }}>{ }</Text>
                <Text variant="titleLarge" style={{ flex: 1, textAlign: "center" }}>તારીખ</Text>
                <Text variant="titleLarge" style={{ flex: 1, borderBottomWidth: 1, borderStyle: "solid" }}>{""}</Text>
            </View>

            <View style={{ flexDirection: "row", marginTop: 40 }}>
                <Text variant="titleLarge" style={{ textAlign: "center" }}>વર્ગ શિક્ષકની સહી </Text>
                <Text variant="titleLarge" style={{ flex: 2, textAlign: "center", borderBottomWidth: 1, borderStyle: "solid" }}>{ }</Text>
                <Text variant="titleLarge" style={{ flex: 1, textAlign: "center" }}>તારીખ</Text>
                <Text variant="titleLarge" style={{ flex: 1, borderBottomWidth: 1, borderStyle: "solid" }}>{""}</Text>
            </View>
        </div>
    }
    const RollSheet = ({ till, above, subject }) => {
        const russia = subject?.students?.filter(e => e?.roll <= till && e?.roll >= above)
        return <View>
            {russia.length > 0 &&
                <View style={{ alignItems: "center", justifyContent: "center", marginRight: 2 }}>
                    <View style={{ flexDirection: "row", alignSelf: "stretch", borderWidth: 1, borderStyle: "solid" }}>
                        <Text variant="titleMedium" style={{ backgroundColor: "#DCDCDC", width: 65, textAlign: "center", borderRightWidth: 1, fontWeight: "900", paddingTop: 2, paddingBottom: 2 }}>રોલ નં</Text>
                        <Text variant="titleMedium" style={{ width: 65, textAlign: "center", fontWeight: "900", paddingTop: 2, paddingBottom: 2 }}>ગુણ</Text>
                    </View>
                    <View style={{ flex: 1 }}>
                        {
                            russia.map(s => {

                                const st1 = { paddingBottom: 4, alignItems: "center", justifyContent: "center", width: 65 }
                                const st2 = { textAlign: "center", paddingTop: 2, paddingBottom: 2 }
                                const style1 = s?.style1 ? s?.style1 : {}
                                const style2 = s?.style2 ? s?.style2 : {}
                                const sty1 = { ...st1, ...style1 }
                                const sty2 = { ...st2, ...style2 }
                                return <View style={{ borderWidth: 1, flexDirection: "row", alignSelf: "stretch", borderStyle: "solid", height: 33 }}>
                                    <Text variant="titleMedium" style={{ alignSelf: "stretch", backgroundColor: "#DCDCDC", width: 65, textAlign: "center", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }}>{s.roll}</Text>
                                    <View style={sty1}>
                                        <Text variant="titleMedium" style={sty2}>{s.value}</Text>
                                    </View>
                                </View>
                            })
                        }
                    </View>
                </View>
            }
        </View >
    }

    const ref = useRef()
    const t = useTheme()
    return <View>
        <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", alignSelf: "flex-start" }}>
            <ReactToPrint
                pageStyle={pageStyle}
                trigger={() => <div style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: t.colors.primary, color: t.colors.onPrimary, padding: 5, borderRadius: 5, paddingRight: 10 }}><MaterialIcons style={{ marginLeft: 5, marginRight: 5 }} name="print" color={t.colors.onPrimary} />Print</div>}
                content={() => ref.current}
            />
            {pref?.current.supervisor == true && <Button onPress={() => {
                try {
                    const workbook = XLSX.utils.book_new();
                    const headers = ["રોલ", "GR", "વિદ્યાર્થી નું નામ"]
                    value.subjects.map(s => headers.push(s.name))
                    headers.push("પરિણામ")
                    headers.push("મેળવેલ ગુણ")
                    headers.push("Rank")
                    const l2: [] = []
                    value?.sheet?.filter(e => e?.totalling !== true)?.map(s => {
                        const me = { "roll": s.student["class" + value.year]?.roll, gr: s.student["class" + value.year]?.gr, name: s.student.name + (Global.isLeft(s.student, value.year) ? "(Left)" : "") }
                        value.subjects.map(e => {
                            const vv = s.subject.find(f => f?.subject_id == e.id)
                            if (vv) {
                                me[e.name] = Global.getValue(vv, "Ab")
                            } else {
                                me[e.name] = ""
                            }
                        }
                        )
                        me.status = Global.isLeft(s.student, value.year) ? "Left" : Global.getResultStatus(s.examObject.status)
                        me.marks = s.examObject.subjectMarks
                        me.rank = s.examObject.rank ? s.examObject.rank : ""
                        l2.push(me)
                    })
                    const worksheet = XLSX.utils.json_to_sheet(l2)
                    //console.log(l2)
                    XLSX.utils.book_append_sheet(workbook, worksheet, "SummarySheet");
                    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
                    XLSX.writeFile(workbook, "SummarySheet" + value.class.name + (value.class.div ? " " + value.class.div : "") + ".xlsx");
                } catch (e) {
                    //console.log("me the e", e)
                    alert("error")
                }
            }}>Export</Button>}
        </View>
        <View>
            <div ref={ref} style={{ display: "block", width: "98%", marginLeft: 10, boxSizing: "border-box" }}>
                <div style={{ paddingLeft: 80, paddingRight: 40, display: "block" }}>
                    {S?.subjectList.map(s => <Page s={s} />)}
                    <div className="pagebreak" />
                </div>

            </div>
        </View >
    </View>
}